/** アーカイブ済みのプロジェクトを一覧に含めるかの切り替え。 */
export function IncludeArchivedCheckbox({
	checked,
	testId,
	onChange,
}: {
	checked: boolean;
	testId: string;
	onChange: (checked: boolean) => void;
}) {
	return (
		<label
			style={{
				display: "flex",
				alignItems: "center",
				gap: 6,
				flexShrink: 0,
				fontSize: "var(--text-ui)",
				color: "var(--fg-2)",
				cursor: "pointer",
				userSelect: "none",
			}}
		>
			<input
				type="checkbox"
				data-testid={testId}
				checked={checked}
				onChange={(e) => onChange(e.target.checked)}
				style={{
					width: 14,
					height: 14,
					margin: 0,
					accentColor: "var(--accent-solid)",
					cursor: "pointer",
				}}
			/>
			アーカイブ済みを含める
		</label>
	);
}
